import { useMemo, useState } from 'react';
import { Card, Col, Row, Dropdown } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import DateFild from '../../components/DateTimePicker/DateFild';
import { FaEye, FaWhatsapp } from "react-icons/fa";

import dayjs from 'dayjs';
import 'dayjs/locale/en';

const Campaigns = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);

    const columns = useMemo(
        () => [
            {
                Header: "Campaign Name",
                accessor: "campaignName",
            },
            {
                Header: "Channel",
                accessor: "channel",
            },
            {
                Header: "Created By",
                accessor: "createdBy",
            },
            {
                Header: "Category",
                accessor: "category",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Attempted",
                accessor: "attempted",
            },
            {
                Header: "Sent",
                accessor: "sent",
            },
            {
                Header: "Delivered",
                accessor: "delivered",
            },
            {
                Header: "Read",
                accessor: "read",
            },
            {
                Header: "Replied",
                accessor: "replied",
            },
            {
                Header: "Set Live",
                accessor: "setLive",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },

        ],
        []
    );

    const data = useMemo(
        () => [
            {
                id: 1,
                campaignName: 'Actuarial Valuations',
                channel: 'Whatsapp',
                createdBy: 'Jenil Shah',
                category: 'Marketing',
                status: 'Live',
                attempted: '3023',
                sent: '2230',
                delivered: '96%',
                read: '53%',
                replied: '3%',
                setLive: '02/04/2026',
            },
            {
                id: 2,
                campaignName: 'Actuarial Valuations',
                channel: 'Whatsapp',
                createdBy: 'Jenil Shah',
                category: '-',
                status: 'Live',
                attempted: '8260',
                sent: '4313',
                delivered: '95%',
                read: '49%',
                replied: '1%',
                setLive: '02/04/2026',
            },
            {
                id: 3,
                campaignName: 'ICAI FAQ Jan 2026_M',
                channel: 'Whatsapp',
                createdBy: 'Jenil Shah',
                category: '-',
                status: 'Completed',
                attempted: '16026',
                sent: '0',
                delivered: '-',
                read: '-',
                replied: '-',
                setLive: '09/04/2026',
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = ['view']

    const formik = useFormik({
        initialValues: '',
        validationSchema: '',
        onSubmit: async (values) => {
            setAddModal(false);
            setEditModal(false);
            formik.resetForm();
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleEdit = (rowData) => {
        setEditModal(true);
    };

    const handleDelete = (rowData) => {

    };

    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);
        formik.resetForm();
    };

    return (
        <>
            <PageTitle titles="Campaigns" active="Campaigns" items={['Home']} />
            <Row>
                <Col md={12}>
                    <Card>
                        <Card.Header>
                            <div className='pagetitle_hed'>
                                <h1>Campaigns</h1>
                            </div>
                            <div className='w-100 d-flex justify-content-end'>
                                <button className='btn btn-primary mr-4' onClick={() => setAddModal(true)}>Create RCS Campaign</button>
                                <button className='btn btn-success ml-4' onClick={() => setAddModal(true)}><FaWhatsapp style={{ marginRight: 5, fontSize: 18 }} />Create Whatsapp Campaign</button>
                            </div>
                        </Card.Header>
                        <Card.Body className="example1-table notAddnew">
                            <div className='filter'>
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <label className="form-label">Select Channel</label>
                                            <SelectFild
                                                Firstop='Select Channel'
                                                selectName="channel"
                                                options={[
                                                    { id: 'WhatsApp', name: 'WhatsApp' },
                                                    { id: 'WhatsApp', name: 'WhatsApp' },
                                                    { id: 'WhatsApp', name: 'WhatsApp' },
                                                    { id: 'WhatsApp', name: 'WhatsApp' },
                                                    { id: 'WhatsApp', name: 'WhatsApp' },
                                                ]}
                                                value={values.channel}
                                                onChange={(selectedOption) => setFieldValue("channel", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <label className="form-label">Select Status</label>
                                            <SelectFild
                                                Firstop='Select Status'
                                                selectName="status"
                                                options={[
                                                    { id: 'Completed', name: 'Completed' },
                                                    { id: 'Live', name: 'Live' },
                                                    { id: 'Open', name: 'Open' },
                                                ]}
                                                value={values.status}
                                                onChange={(selectedOption) => setFieldValue("status", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <label className="form-label">Select Category</label>
                                            <SelectFild
                                                Firstop='Select Category'
                                                selectName="category"
                                                options={[
                                                    { id: 'Marketing', name: 'Marketing' },
                                                ]}
                                                value={values.category}
                                                onChange={(selectedOption) => setFieldValue("category", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <label className="form-label">Select Created By</label>
                                            <SelectFild
                                                Firstop='Select Created By'
                                                selectName="createdBy"
                                                options={[
                                                    { id: 'Jenil Shah', name: 'Jenil Shah' },
                                                    { id: 'Piyush Parmar', name: 'Piyush Parmar' },
                                                    { id: 'Hatim Musani', name: 'Hatim Musani' },
                                                ]}
                                                value={values.category}
                                                onChange={(selectedOption) => setFieldValue("createdBy", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <Tables
                                columns={columns}
                                data={data}
                                actions={actions}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                            />
                        </Card.Body>

                    </Card>
                </Col>
            </Row>

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title="Add new"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                </form>
            </Modals>

            <Modals
                show={editModal}
                handleClose={() => setEditModal(false)}
                title="Edit Project"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">

                </form>
            </Modals>
        </>
    )
}

export default Campaigns